var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8DoctorsBag128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "128px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M96,103.5H32c-5.5,0-10-4.5-10-10V43.7c0-5.5,4.5-10,10-10h64c5.5,0,10,4.5,10,10v49.8C106,99.1,101.5,103.5,96,103.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32 43.7H96V93.5H32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#454B54",
    d: "M96 106.5H32c-7.2 0-13-5.8-13-13V43.7c0-7.2 5.8-13 13-13h64c7.2 0 13 5.8 13 13v49.8C109 100.7 103.2 106.5 96 106.5zM32 36.7c-3.9 0-7 3.1-7 7v49.8c0 3.9 3.1 7 7 7h64c3.9 0 7-3.1 7-7V43.7c0-3.9-3.1-7-7-7H32zM79 27.5c-.4 0-.7-.1-1.1-.2L64 21.7l-13.9 5.6c-1.5.6-3.3-.1-3.9-1.7-.6-1.5.1-3.3 1.7-3.9l15-6c.7-.3 1.5-.3 2.2 0l15 6c1.5.6 2.3 2.4 1.7 3.9C81.3 26.8 80.2 27.5 79 27.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37778",
    d: "M76.2,64.8H69v-7.2c0-2.8-2.2-5-5-5s-5,2.2-5,5v7.2h-7.2c-2.8,0-5,2.2-5,5s2.2,5,5,5H59V82c0,2.8,2.2,5,5,5s5-2.2,5-5v-7.2h7.2c2.8,0,5-2.2,5-5S78.9,64.8,76.2,64.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DoctorsBag128);
export default __webpack_public_path__ + "static/media/icons8-doctors-bag-128.46c593b408c8813f50d5a28593273972.svg";
export { ForwardRef as ReactComponent };